import React from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import classNames from 'classnames';
import { H2, NamedLink } from '../../../components';
import { lazyLoadWithDimensions } from '../../../util/uiHelpers';

import bandGroupImage from './images/band-group.png';

import css from './SectionWhyChooseUs.module.css';

const Image = props => {
  const { alt, ...rest } = props;

  return <img {...rest} alt={alt} />;
};

const LazyImage = lazyLoadWithDimensions(Image, {
  loadAfterInitialRendering: 3000,
});

const SectionWhyChooseUs = props => {
  const { className } = props;

  const intl = useIntl();

  const classes = classNames(css.root, className);

  const ctas = (
    <div className={css.ctas}>
      <NamedLink name="ArtistSignupPage" className={css.primaryCta}>
        {intl.formatMessage({ id: 'General.artistSignup' })}
      </NamedLink>

      <NamedLink name="ArtistHelpPage" className={css.secondaryCta}>
        {intl.formatMessage({ id: 'General.learnMore' })}
      </NamedLink>
    </div>
  );

  return (
    <div className={classes}>
      <div className={css.content}>
        <div className={css.text}>
          <H2 className={css.title}>
            <FormattedMessage id="SectionWhyChooseUs.title" />
          </H2>

          <div className={css.desc}>{intl.formatMessage({ id: 'SectionWhyChooseUs.desc' })}</div>

          <div className={css.desktopCtas}>{ctas}</div>
        </div>

        <div className={css.images}>
          <LazyImage src={bandGroupImage} alt="" />
        </div>

        <div className={css.mobileCtas}>{ctas}</div>
      </div>
      <div className={css.gradient} />
    </div>
  );
};

export default SectionWhyChooseUs;
